import { Group } from "../../admin/models/group.model";
import { Contact } from "../../admin/models/contact.model";
import { FlowInstance, FileUploadQuestion } from "../../flow/models/flow.model";
import { RequestForScanning } from "../models/scan-documents.model";

export class PendingWorkOrderAssignment {
    assignedUserId: string;
    assignedUserName: string;
    flowInstanceId: string;
    reindexFlow: boolean = false;
    workOrderId: string;
    

    constructor(orderId: string, userId: string, userName: string, reindex: boolean = false, instanceId: string = "") {
        this.workOrderId = orderId;
        this.assignedUserId = userId;
        this.assignedUserName = userName;
        this.reindexFlow = reindex;
        this.flowInstanceId = instanceId;
    }

}

export class WorkOrder {
    id: string;
    blockOnOtherOutstandingWorkOrders: boolean;
    parentTaskId?: string;
    title: string;
    description: string;
    assignedUserId?: string;
    assignedGroupId?: string;
    lastUpdatedUserId?: string;
    targetUrl: string;
    creatorId?: string;
    flowInstanceId?: string;
    flowTemplateId?: string;
    flowTargetState: string;
    dueDate?: string;
    status: WorkOrderStatus = WorkOrderStatus.Pending;
    type: WorkOrderType = WorkOrderType.AdHoc;
    transition?: string;
    transitionName?: string;
    reviewEntities?: any; // will be a list of JObjects
    organizationId?: string
    creationDate?: Date
    lastUpdatedDate?: Date;
    applicationNumber: string;
    companyName: string;
    isExpedited?: string;
    scanRequest?: RequestForScanning;
}

export class WorkOrderWithAssignments extends WorkOrder {
    assignee: Contact;
    creator: Contact;
    lastModifiedUser: Contact;
    assignedGroup: Group;
    organizationName: string;    
}

export class ScanOrder extends WorkOrder {
    workOrderId: string;
    applicationNumber: string;
    companyName: string;
    description: string;
    assignedUserId?: string;
    assignedGroupId?: string;
    flowInstance: FlowInstance;    
    status: WorkOrderStatus;    
    organizationId?: string;
    scanRequest?: RequestForScanning;
    type: WorkOrderType = WorkOrderType.ScanDocuments;
    uploads: FileUploadQuestion[];
}

export enum WorkOrderStatus {
    Pending,
    Waiting,
    Returned,
    Completed,
    Cancelled,
    NotSubmitted,    
    ApplicationRejected,
    ApplicationApproved
}

export enum WorkOrderType {
    AdHoc,
    Permit,
    Review,
    AdHocReview,
    ReviewExpedite,
    AcceptApplication,
    CertifiedMail,
    StandardMail,
    ScanDocuments,
    Resubmit,
    WellTransfer,
    LegalReviewScannedDocuments,
    ReviewScannedDocuments    
}

